module.exports = __webpack_public_path__ + "static/media/certificates-page-banner-1.4276ff15.jpg";